import React from 'react';
import styled from '@emotion/styled';
import TruckIcon from '../../svg/tabs/TruckIcon';
import CardIcon from '../../svg/tabs/CardIcon';
import TickIcon from '../../svg/tabs/TickIcon';

const StyledCartHeaderTabs = styled.div`
	.checkout_step {
		border-bottom: 2px solid transparent;
		transition: border-color 0.3s ease-in-out;
		padding: 0 16px;

		&.active {
			border-color: #212121;
		}
	}
`;

function CartHeader({ title = '', step, setStep, cartData }) {
	return (
		<>
			{title && (
				<div className='cart__header mb-35'>
					<h6 className='mb-12'>{title}</h6>
				</div>
			)}

			{((cartData && cartData.length > 0) || step === 3 || step === 4) && (
				<StyledCartHeaderTabs className='cart__header__tabs mb-20'>
					<div className='d-flex justify-content-around align-items-center border-bottom-light-medium'>
						<div
							className={`text-center checkout_step ${
								step <= 2 ? 'active' : ''
							} cursor-${step >= 3 && step !== 4 ? 'pointer' : 'default'}`}
							onClick={() => step >= 3 && step !== 4 && setStep(2)}
							title={step >= 3 ? 'Edit Delivery Details' : 'Delivery'}
						>
							<div className='mb-10'>
								<TruckIcon className={step <= 2 ? 'active' : ''} />
							</div>
							<div className='text-uppercase text-small pb-10'>Delivery</div>
						</div>
						<div
							className={`text-center checkout_step ${
								step === 3 ? 'active' : ''
							} cursor-default`}
							title='Payment'
						>
							<div className='mb-10'>
								<CardIcon className={step === 3 ? 'active' : ''} />
							</div>
							<div className='text-uppercase text-small pb-10'>Payment</div>
						</div>
						<div
							className={`text-center checkout_step ${
								step === 4 ? 'active' : ''
							} cursor-default`}
							title='Done'
						>
							<div className='mb-10'>
								<TickIcon className={step === 4 ? 'active' : ''} />
							</div>
							<div className='text-uppercase text-small pb-10'>Done</div>
						</div>
					</div>
				</StyledCartHeaderTabs>
			)}
		</>
	);
}

export default CartHeader;
